
















import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import Scoring from "../../store/modules/Scoring";
import Viewpoints from "@/store/modules/Viewpoints";
import _ from "lodash";

const scoringModule = getModule(Scoring)
const viewpointsModule = getModule(Viewpoints);
@Component
export default class RefreshScoringButton extends Vue {

    private fetching = false;

    get display() {
        return this.invalidatedStatus;
    }

    get invalidatedStatus() {
        return _.intersection(Object.keys(scoringModule.invalidatedViewpointScoring), viewpointsModule.selectedViewpointIds).length;
    }

    private async fetchScores() {
        this.fetching = true;
        await scoringModule.refreshScoring()
        this.fetching = false;
    }
}
